import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useChangeSharesTitleStatusModal } from '../context/ChangeSharesTitleStatusModalContext';

const ChangeSharesTitleStatusModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useChangeSharesTitleStatusModal();

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary "
          onClick={actions.handleSaveStatus}
          disabled={!data.status}
        >
          {t('Change')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default ChangeSharesTitleStatusModalFooter;
